/**
 * Almari bootstrap. Registers components, wires gate -> app.
 */
import './components/gate.ts';
import './spatial/scene.ts';
import './components/tier-card.ts';
import './components/value-spotlight.ts';
import './components/capsule-grid.ts';
import './components/most-worn.ts';
import './components/brand-rank.ts';
import './components/category-rank.ts';
import './components/palette-strip.ts';
import './components/dead-weight.ts';
import './components/share-card.ts';
// AAA genius surfaces
import './components/outfit-recommender.ts';
import './components/clip-vault.ts';
import './components/carbon-footprint.ts';
import './components/wishlist.ts';
import './components/connect-section.ts';
import './components/upgrade-card.ts';
import './components/pay-cta.ts';

import { store } from './store.ts';
import { loadSummary } from './storage.ts';
import { decryptJSON } from './crypto.ts';
import { formatINR } from './types.ts';
import type { WardrobeSummary } from './types.ts';
import './sync/sync-v2.ts';

async function bootstrap(): Promise<void> {
  const cached = await loadSummary();
  if (cached) {
    store.patch({ phase: 'ready', summary: cached });
    revealApp();
    refreshHero(cached);
    return;
  }

  const hashPasscode = location.hash.slice(1).trim();
  const sessionPasscode = sessionStorage.getItem('almari:passcode') ?? '';
  const passcode = hashPasscode || sessionPasscode;
  if (passcode) {
    try {
      const summary = await fetchAndDecrypt(passcode);
      store.patch({ phase: 'ready', summary });
      revealApp();
      refreshHero(summary);
      return;
    } catch {
      // fall through to gate
    }
  }
  store.patch({ phase: 'gate' });
  showGate();
}

async function fetchAndDecrypt(passcode: string): Promise<WardrobeSummary> {
  const r = await fetch('/data.encrypted.json', { cache: 'no-cache' });
  if (!r.ok) throw new Error('fetch failed');
  const body = await r.json() as { ciphertext: string };
  return decryptJSON<WardrobeSummary>(passcode, body.ciphertext);
}

function showGate(): void {
  const gate = document.querySelector('almari-gate');
  const app = document.getElementById('app');
  if (gate) gate.removeAttribute('hidden');
  if (app) app.hidden = true;
}

function revealApp(): void {
  const gate = document.querySelector('almari-gate');
  const app = document.getElementById('app');
  if (gate) gate.setAttribute('hidden', '');
  if (app) app.hidden = false;
}

function refreshHero(s: WardrobeSummary): void {
  const total = document.getElementById('total');
  const sub = document.getElementById('hero-sub');
  if (total) total.textContent = formatINR(s.total_current_value_inr);
  if (sub) sub.textContent = `${s.total_items} pieces · purchase ${formatINR(s.total_value_inr)}`;
}

store.subscribe((s) => {
  if (s.phase === 'ready' && s.summary) {
    revealApp();
    refreshHero(s.summary);
  }
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* ignore */ });
  });
}

bootstrap();
import { mountAmbient as mountEmpireSelf } from './agent/hook.ts';
queueMicrotask(() => mountEmpireSelf());
